// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uppy-ImageCropper-range {
  -webkit-appearance: none;
  background: transparent;
  margin: 8px 0;
  width: 100%;
}
.uppy-ImageCropper-range::-moz-focus-outer {
  border: 0;
}
.uppy-ImageCropper-range:focus {
  outline: 0;
}
.uppy-ImageCropper-range:focus::-webkit-slider-runnable-track {
  background: rgba(255, 255, 255, 0.2);
}
.uppy-ImageCropper-range:focus::-ms-fill-lower {
  background: rgba(255, 255, 255, 0.2);
}
.uppy-ImageCropper-range:focus::-ms-fill-upper {
  background: rgba(255, 255, 255, 0.2);
}
.uppy-ImageCropper-range::-webkit-slider-runnable-track {
  cursor: default;
  height: 4px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 100%;
  box-shadow: 0 0 0 transparent, 0 0 0 rgba(13, 13, 13, 0);
  background: rgba(255, 255, 255, 0.2);
  border: 0 solid transparent;
  border-radius: 5px;
}
.uppy-ImageCropper-range::-webkit-slider-thumb {
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2), 0 0 0 rgba(13, 13, 13, 0.2);
  background: #fff;
  border: 0 solid transparent;
  border-radius: 9px;
  box-sizing: border-box;
  cursor: default;
  height: 16px;
  width: 16px;
  -webkit-appearance: none;
  margin-top: -6px;
}
.uppy-ImageCropper-range::-moz-range-track {
  box-shadow: 0 0 0 transparent, 0 0 0 rgba(13, 13, 13, 0);
  cursor: default;
  -moz-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 100%;
  background: rgba(255, 255, 255, 0.2);
  border: 0 solid transparent;
  border-radius: 5px;
  height: 2px;
}
.uppy-ImageCropper-range::-moz-range-thumb {
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2), 0 0 0 rgba(13, 13, 13, 0.2);
  background: #fff;
  border: 0 solid transparent;
  border-radius: 9px;
  box-sizing: border-box;
  cursor: default;
  height: 16px;
  width: 16px;
}
.uppy-ImageCropper-range::-ms-track {
  cursor: default;
  height: 4px;
  -ms-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 100%;
  background: transparent;
  border-color: transparent;
  border-width: 8px 0;
  color: transparent;
}
.uppy-ImageCropper-range::-ms-fill-lower {
  box-shadow: 0 0 0 transparent, 0 0 0 rgba(13, 13, 13, 0);
  background: rgba(242, 242, 242, 0.2);
  border: 0 solid transparent;
  border-radius: 10px;
}
.uppy-ImageCropper-range::-ms-fill-upper {
  box-shadow: 0 0 0 transparent, 0 0 0 rgba(13, 13, 13, 0);
  background: rgba(255, 255, 255, 0.2);
  border: 0 solid transparent;
  border-radius: 10px;
}
.uppy-ImageCropper-range::-ms-thumb {
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2), 0 0 0 rgba(13, 13, 13, 0.2);
  background: #fff;
  border: 0 solid transparent;
  border-radius: 9px;
  box-sizing: border-box;
  cursor: default;
  height: 16px;
  width: 16px;
  margin-top: 1px;
}
.uppy-ImageCropper-range:disabled::-webkit-slider-thumb, .uppy-ImageCropper-range:disabled::-moz-range-thumb, .uppy-ImageCropper-range:disabled::-ms-thumb, .uppy-ImageCropper-range:disabled::-webkit-slider-runnable-track, .uppy-ImageCropper-range:disabled::-ms-fill-lower, .uppy-ImageCropper-range:disabled::-ms-fill-upper {
  cursor: not-allowed;
}

/*!
 * Cropper.js v1.5.6
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2019-10-04T04:33:44.164Z
 */
.cropper-container {
  position: relative;
  font-size: 0;
  line-height: 0;
  direction: ltr;
  -webkit-user-select: none;
  -moz-user-select: none;
       user-select: none;
  touch-action: none;
}

.cropper-container img {
  display: block;
  width: 100%;
  min-width: 0 !important;
  max-width: none !important;
  height: 100%;
  min-height: 0 !important;
  max-height: none !important;
  image-orientation: 0deg;
}

.cropper-wrap-box,
.cropper-canvas,
.cropper-drag-box,
.cropper-crop-box,
.cropper-modal {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.cropper-wrap-box,
.cropper-canvas {
  overflow: hidden;
}

.cropper-drag-box {
  background-color: #fff;
  opacity: 0;
}

.cropper-modal {
  background-color: #000;
  opacity: 0.5;
}

.cropper-view-box {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 1px solid #39f;
  outline-color: rgba(51, 153, 255, 0.75);
}

.cropper-dashed {
  position: absolute;
  display: block;
  border: 0 dashed #eee;
  opacity: 0.5;
}

.cropper-dashed.dashed-h {
  top: 33.3333333333%;
  left: 0;
  width: 100%;
  height: 33.3333333333%;
  border-top-width: 1px;
  border-bottom-width: 1px;
}

.cropper-dashed.dashed-v {
  top: 0;
  left: 33.3333333333%;
  width: 33.3333333333%;
  height: 100%;
  border-right-width: 1px;
  border-left-width: 1px;
}

.cropper-center {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 0;
  height: 0;
  opacity: 0.75;
}

.cropper-center::before,
.cropper-center::after {
  position: absolute;
  display: block;
  background-color: #eee;
  content: " ";
}

.cropper-center::before {
  top: 0;
  left: -3px;
  width: 7px;
  height: 1px;
}

.cropper-center::after {
  top: -3px;
  left: 0;
  width: 1px;
  height: 7px;
}

.cropper-face,
.cropper-line,
.cropper-point {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  opacity: 0.1;
}

.cropper-face {
  top: 0;
  left: 0;
  background-color: #fff;
}

.cropper-line {
  background-color: #39f;
}

.cropper-line.line-e {
  top: 0;
  right: -3px;
  width: 5px;
  cursor: ew-resize;
}

.cropper-line.line-n {
  top: -3px;
  left: 0;
  height: 5px;
  cursor: ns-resize;
}

.cropper-line.line-w {
  top: 0;
  left: -3px;
  width: 5px;
  cursor: ew-resize;
}

.cropper-line.line-s {
  bottom: -3px;
  left: 0;
  height: 5px;
  cursor: ns-resize;
}

.cropper-point {
  width: 5px;
  height: 5px;
  background-color: #39f;
  opacity: 0.75;
}

.cropper-point.point-e {
  top: 50%;
  right: -3px;
  margin-top: -3px;
  cursor: ew-resize;
}

.cropper-point.point-n {
  top: -3px;
  left: 50%;
  margin-left: -3px;
  cursor: ns-resize;
}

.cropper-point.point-w {
  top: 50%;
  left: -3px;
  margin-top: -3px;
  cursor: ew-resize;
}

.cropper-point.point-s {
  bottom: -3px;
  left: 50%;
  margin-left: -3px;
  cursor: s-resize;
}

.cropper-point.point-ne {
  top: -3px;
  right: -3px;
  cursor: nesw-resize;
}

.cropper-point.point-nw {
  top: -3px;
  left: -3px;
  cursor: nwse-resize;
}

.cropper-point.point-sw {
  bottom: -3px;
  left: -3px;
  cursor: nesw-resize;
}

.cropper-point.point-se {
  right: -3px;
  bottom: -3px;
  width: 20px;
  height: 20px;
  cursor: nwse-resize;
  opacity: 1;
}

@media (min-width: 768px) {
  .cropper-point.point-se {
    width: 15px;
    height: 15px;
  }
}
@media (min-width: 992px) {
  .cropper-point.point-se {
    width: 10px;
    height: 10px;
  }
}
@media (min-width: 1200px) {
  .cropper-point.point-se {
    width: 5px;
    height: 5px;
    opacity: 0.75;
  }
}
.cropper-point.point-se::before {
  position: absolute;
  right: -50%;
  bottom: -50%;
  display: block;
  width: 200%;
  height: 200%;
  background-color: #39f;
  opacity: 0;
  content: " ";
}

.cropper-invisible {
  opacity: 0;
}

.cropper-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.cropper-hide {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
}

.cropper-hidden {
  display: none !important;
}

.cropper-move {
  cursor: move;
}

.cropper-crop {
  cursor: crosshair;
}

.cropper-disabled .cropper-drag-box,
.cropper-disabled .cropper-face,
.cropper-disabled .cropper-line,
.cropper-disabled .cropper-point {
  cursor: not-allowed;
}

.uppy-ImageCropper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.uppy-ImageCropper-container {
  flex-grow: 1;
}

.uppy-ImageCropper-image {
  display: block;
  max-width: 100%;
  max-height: 400px;
}

.uppy-ImageCropper-controls {
  position: absolute;
  bottom: 15px;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 38px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
  transform: translateX(-50%);
  border-radius: 5px;
}
.uppy-size--md .uppy-ImageCropper-controls {
  padding-top: 0;
}

.uppy-ImageCropper-controls button {
  width: 35px;
  height: 35px;
  border-radius: 5px;
}
.uppy-ImageCropper-controls button svg {
  padding: 3px;
}
.uppy-size--md .uppy-ImageCropper-controls button {
  width: 40px;
  height: 40px;
}
.uppy-size--md .uppy-ImageCropper-controls button svg {
  padding: 1px;
}
.uppy-ImageCropper-controls button:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
.uppy-ImageCropper-controls button:focus {
  background-color: rgba(255, 255, 255, 0.5);
  outline: none;
}

.uppy-Dashboard:not(.uppy-size--md) .uppy-ImageCropper-rangeWrapper {
  position: absolute !important;
  top: 0;
  right: 10px;
  left: 10px;
  height: 38px;
}

.uppy-size--md .uppy-ImageCropper-range {
  width: 180px;
  margin-right: 5px;
  margin-left: 5px;
}

.uppy-ImageCropper .cropper-point {
  width: 8px;
  height: 8px;
}

.uppy-ImageCropper .cropper-view-box {
  outline: 2px solid #39f;
  background: repeating-conic-gradient(rgba(189, 189, 189, 0.2) 0%,rgba(189, 189, 189, 0.2) 25%, white 0%, white 50%) 50%/16px 16px;
  background: repeating-conic-gradient(rgba(189, 189, 189, 0.2) 0% 25%, white 0% 50%) 50%/16px 16px;
}
[data-uppy-theme=dark] .uppy-ImageCropper .cropper-view-box {
  background: repeating-conic-gradient(rgb(43, 42, 42) 0%,rgb(43, 42, 42) 25%, black 0%, black 50%) 50%/16px 16px;
  background: repeating-conic-gradient(rgb(43, 42, 42) 0% 25%, black 0% 50%) 50%/16px 16px;
}

.uppy-ImageCropper .cropper-modal {
  opacity: 0.9;
  background-color: white;
}
[data-uppy-theme=dark] .uppy-ImageCropper .cropper-modal {
  opacity: 0.7;
  background-color: black;
}

.uppy-ImageCropper .cropper-face {
  opacity: 0;
}

.uppy-ImageCropper-range::-moz-range-track {
  height: 4px;
}
.uppy-ImageCropper-range:focus::-webkit-slider-runnable-track, .uppy-ImageCropper-range:hover::-webkit-slider-runnable-track {
  background: rgba(255, 255, 255, 0.5);
}
.uppy-ImageCropper-range:focus::-ms-fill-lower, .uppy-ImageCropper-range:hover::-ms-fill-lower {
  background: rgba(255, 255, 255, 0.5);
}
.uppy-ImageCropper-range:focus::-ms-fill-upper, .uppy-ImageCropper-range:hover::-ms-fill-upper {
  background: rgba(255, 255, 255, 0.5);
}
.uppy-ImageCropper-range:focus::-moz-range-track, .uppy-ImageCropper-range:hover::-moz-range-track {
  background: rgba(255, 255, 255, 0.5);
}`, "",{"version":3,"sources":["webpack://./node_modules/@uppy/image-editor/dist/style.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,WAAW;EAEX,iCAAyB;EAAzB,yBAAyB;EACzB,WAAW;EACX,wDAAwD;EACxD,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,mEAAmE;EACnE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,wDAAwD;EACxD,eAAe;EAGf,8BAAyB;EAAzB,yBAAyB;EACzB,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mEAAmE;EACnE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EAEX,6BAAyB;EAAzB,yBAAyB;EACzB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,wDAAwD;EACxD,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,wDAAwD;EACxD,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,mEAAmE;EACnE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE;AACF;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,sBAAiB;OAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,0BAA0B;EAC1B,YAAY;EACZ,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;;;;;EAKE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,MAAM;EACN,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,QAAQ;EACR,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,MAAM;EACN,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;EACE,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,MAAM;EACN,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,UAAU;EACV,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,UAAU;IACV,WAAW;IACX,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yDAA+Q;AACjR;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,iIAAiG;EAAjG,iGAAiG;AACnG;AACA;EACE,+GAAwF;EAAxF,wFAAwF;AAC1F;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".uppy-ImageCropper-range {\n  -webkit-appearance: none;\n  background: transparent;\n  margin: 8px 0;\n  width: 100%;\n}\n.uppy-ImageCropper-range::-moz-focus-outer {\n  border: 0;\n}\n.uppy-ImageCropper-range:focus {\n  outline: 0;\n}\n.uppy-ImageCropper-range:focus::-webkit-slider-runnable-track {\n  background: rgba(255, 255, 255, 0.2);\n}\n.uppy-ImageCropper-range:focus::-ms-fill-lower {\n  background: rgba(255, 255, 255, 0.2);\n}\n.uppy-ImageCropper-range:focus::-ms-fill-upper {\n  background: rgba(255, 255, 255, 0.2);\n}\n.uppy-ImageCropper-range::-webkit-slider-runnable-track {\n  cursor: default;\n  height: 4px;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  width: 100%;\n  box-shadow: 0 0 0 transparent, 0 0 0 rgba(13, 13, 13, 0);\n  background: rgba(255, 255, 255, 0.2);\n  border: 0 solid transparent;\n  border-radius: 5px;\n}\n.uppy-ImageCropper-range::-webkit-slider-thumb {\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2), 0 0 0 rgba(13, 13, 13, 0.2);\n  background: #fff;\n  border: 0 solid transparent;\n  border-radius: 9px;\n  box-sizing: border-box;\n  cursor: default;\n  height: 16px;\n  width: 16px;\n  -webkit-appearance: none;\n  margin-top: -6px;\n}\n.uppy-ImageCropper-range::-moz-range-track {\n  box-shadow: 0 0 0 transparent, 0 0 0 rgba(13, 13, 13, 0);\n  cursor: default;\n  height: 4px;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  width: 100%;\n  background: rgba(255, 255, 255, 0.2);\n  border: 0 solid transparent;\n  border-radius: 5px;\n  height: 2px;\n}\n.uppy-ImageCropper-range::-moz-range-thumb {\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2), 0 0 0 rgba(13, 13, 13, 0.2);\n  background: #fff;\n  border: 0 solid transparent;\n  border-radius: 9px;\n  box-sizing: border-box;\n  cursor: default;\n  height: 16px;\n  width: 16px;\n}\n.uppy-ImageCropper-range::-ms-track {\n  cursor: default;\n  height: 4px;\n  -ms-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  width: 100%;\n  background: transparent;\n  border-color: transparent;\n  border-width: 8px 0;\n  color: transparent;\n}\n.uppy-ImageCropper-range::-ms-fill-lower {\n  box-shadow: 0 0 0 transparent, 0 0 0 rgba(13, 13, 13, 0);\n  background: rgba(242, 242, 242, 0.2);\n  border: 0 solid transparent;\n  border-radius: 10px;\n}\n.uppy-ImageCropper-range::-ms-fill-upper {\n  box-shadow: 0 0 0 transparent, 0 0 0 rgba(13, 13, 13, 0);\n  background: rgba(255, 255, 255, 0.2);\n  border: 0 solid transparent;\n  border-radius: 10px;\n}\n.uppy-ImageCropper-range::-ms-thumb {\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2), 0 0 0 rgba(13, 13, 13, 0.2);\n  background: #fff;\n  border: 0 solid transparent;\n  border-radius: 9px;\n  box-sizing: border-box;\n  cursor: default;\n  height: 16px;\n  width: 16px;\n  margin-top: 1px;\n}\n.uppy-ImageCropper-range:disabled::-webkit-slider-thumb, .uppy-ImageCropper-range:disabled::-moz-range-thumb, .uppy-ImageCropper-range:disabled::-ms-thumb, .uppy-ImageCropper-range:disabled::-webkit-slider-runnable-track, .uppy-ImageCropper-range:disabled::-ms-fill-lower, .uppy-ImageCropper-range:disabled::-ms-fill-upper {\n  cursor: not-allowed;\n}\n\n/*!\n * Cropper.js v1.5.6\n * https://fengyuanchen.github.io/cropperjs\n *\n * Copyright 2015-present Chen Fengyuan\n * Released under the MIT license\n *\n * Date: 2019-10-04T04:33:44.164Z\n */\n.cropper-container {\n  position: relative;\n  font-size: 0;\n  line-height: 0;\n  direction: ltr;\n  -webkit-user-select: none;\n  user-select: none;\n  touch-action: none;\n}\n\n.cropper-container img {\n  display: block;\n  width: 100%;\n  min-width: 0 !important;\n  max-width: none !important;\n  height: 100%;\n  min-height: 0 !important;\n  max-height: none !important;\n  image-orientation: 0deg;\n}\n\n.cropper-wrap-box,\n.cropper-canvas,\n.cropper-drag-box,\n.cropper-crop-box,\n.cropper-modal {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.cropper-wrap-box,\n.cropper-canvas {\n  overflow: hidden;\n}\n\n.cropper-drag-box {\n  background-color: #fff;\n  opacity: 0;\n}\n\n.cropper-modal {\n  background-color: #000;\n  opacity: 0.5;\n}\n\n.cropper-view-box {\n  display: block;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 1px solid #39f;\n  outline-color: rgba(51, 153, 255, 0.75);\n}\n\n.cropper-dashed {\n  position: absolute;\n  display: block;\n  border: 0 dashed #eee;\n  opacity: 0.5;\n}\n\n.cropper-dashed.dashed-h {\n  top: 33.3333333333%;\n  left: 0;\n  width: 100%;\n  height: 33.3333333333%;\n  border-top-width: 1px;\n  border-bottom-width: 1px;\n}\n\n.cropper-dashed.dashed-v {\n  top: 0;\n  left: 33.3333333333%;\n  width: 33.3333333333%;\n  height: 100%;\n  border-right-width: 1px;\n  border-left-width: 1px;\n}\n\n.cropper-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: block;\n  width: 0;\n  height: 0;\n  opacity: 0.75;\n}\n\n.cropper-center::before,\n.cropper-center::after {\n  position: absolute;\n  display: block;\n  background-color: #eee;\n  content: \" \";\n}\n\n.cropper-center::before {\n  top: 0;\n  left: -3px;\n  width: 7px;\n  height: 1px;\n}\n\n.cropper-center::after {\n  top: -3px;\n  left: 0;\n  width: 1px;\n  height: 7px;\n}\n\n.cropper-face,\n.cropper-line,\n.cropper-point {\n  position: absolute;\n  display: block;\n  width: 100%;\n  height: 100%;\n  opacity: 0.1;\n}\n\n.cropper-face {\n  top: 0;\n  left: 0;\n  background-color: #fff;\n}\n\n.cropper-line {\n  background-color: #39f;\n}\n\n.cropper-line.line-e {\n  top: 0;\n  right: -3px;\n  width: 5px;\n  cursor: ew-resize;\n}\n\n.cropper-line.line-n {\n  top: -3px;\n  left: 0;\n  height: 5px;\n  cursor: ns-resize;\n}\n\n.cropper-line.line-w {\n  top: 0;\n  left: -3px;\n  width: 5px;\n  cursor: ew-resize;\n}\n\n.cropper-line.line-s {\n  bottom: -3px;\n  left: 0;\n  height: 5px;\n  cursor: ns-resize;\n}\n\n.cropper-point {\n  width: 5px;\n  height: 5px;\n  background-color: #39f;\n  opacity: 0.75;\n}\n\n.cropper-point.point-e {\n  top: 50%;\n  right: -3px;\n  margin-top: -3px;\n  cursor: ew-resize;\n}\n\n.cropper-point.point-n {\n  top: -3px;\n  left: 50%;\n  margin-left: -3px;\n  cursor: ns-resize;\n}\n\n.cropper-point.point-w {\n  top: 50%;\n  left: -3px;\n  margin-top: -3px;\n  cursor: ew-resize;\n}\n\n.cropper-point.point-s {\n  bottom: -3px;\n  left: 50%;\n  margin-left: -3px;\n  cursor: s-resize;\n}\n\n.cropper-point.point-ne {\n  top: -3px;\n  right: -3px;\n  cursor: nesw-resize;\n}\n\n.cropper-point.point-nw {\n  top: -3px;\n  left: -3px;\n  cursor: nwse-resize;\n}\n\n.cropper-point.point-sw {\n  bottom: -3px;\n  left: -3px;\n  cursor: nesw-resize;\n}\n\n.cropper-point.point-se {\n  right: -3px;\n  bottom: -3px;\n  width: 20px;\n  height: 20px;\n  cursor: nwse-resize;\n  opacity: 1;\n}\n\n@media (min-width: 768px) {\n  .cropper-point.point-se {\n    width: 15px;\n    height: 15px;\n  }\n}\n@media (min-width: 992px) {\n  .cropper-point.point-se {\n    width: 10px;\n    height: 10px;\n  }\n}\n@media (min-width: 1200px) {\n  .cropper-point.point-se {\n    width: 5px;\n    height: 5px;\n    opacity: 0.75;\n  }\n}\n.cropper-point.point-se::before {\n  position: absolute;\n  right: -50%;\n  bottom: -50%;\n  display: block;\n  width: 200%;\n  height: 200%;\n  background-color: #39f;\n  opacity: 0;\n  content: \" \";\n}\n\n.cropper-invisible {\n  opacity: 0;\n}\n\n.cropper-bg {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC\");\n}\n\n.cropper-hide {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n}\n\n.cropper-hidden {\n  display: none !important;\n}\n\n.cropper-move {\n  cursor: move;\n}\n\n.cropper-crop {\n  cursor: crosshair;\n}\n\n.cropper-disabled .cropper-drag-box,\n.cropper-disabled .cropper-face,\n.cropper-disabled .cropper-line,\n.cropper-disabled .cropper-point {\n  cursor: not-allowed;\n}\n\n.uppy-ImageCropper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n\n.uppy-ImageCropper-container {\n  flex-grow: 1;\n}\n\n.uppy-ImageCropper-image {\n  display: block;\n  max-width: 100%;\n  max-height: 400px;\n}\n\n.uppy-ImageCropper-controls {\n  position: absolute;\n  bottom: 15px;\n  left: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 38px;\n  color: #fff;\n  background-color: rgba(0, 0, 0, 0.6);\n  transform: translateX(-50%);\n  border-radius: 5px;\n}\n.uppy-size--md .uppy-ImageCropper-controls {\n  padding-top: 0;\n}\n\n.uppy-ImageCropper-controls button {\n  width: 35px;\n  height: 35px;\n  border-radius: 5px;\n}\n.uppy-ImageCropper-controls button svg {\n  padding: 3px;\n}\n.uppy-size--md .uppy-ImageCropper-controls button {\n  width: 40px;\n  height: 40px;\n}\n.uppy-size--md .uppy-ImageCropper-controls button svg {\n  padding: 1px;\n}\n.uppy-ImageCropper-controls button:hover {\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.uppy-ImageCropper-controls button:focus {\n  background-color: rgba(255, 255, 255, 0.5);\n  outline: none;\n}\n\n.uppy-Dashboard:not(.uppy-size--md) .uppy-ImageCropper-rangeWrapper {\n  position: absolute !important;\n  top: 0;\n  right: 10px;\n  left: 10px;\n  height: 38px;\n}\n\n.uppy-size--md .uppy-ImageCropper-range {\n  width: 180px;\n  margin-right: 5px;\n  margin-left: 5px;\n}\n\n.uppy-ImageCropper .cropper-point {\n  width: 8px;\n  height: 8px;\n}\n\n.uppy-ImageCropper .cropper-view-box {\n  outline: 2px solid #39f;\n  background: repeating-conic-gradient(rgba(189, 189, 189, 0.2) 0% 25%, white 0% 50%) 50%/16px 16px;\n}\n[data-uppy-theme=dark] .uppy-ImageCropper .cropper-view-box {\n  background: repeating-conic-gradient(rgb(43, 42, 42) 0% 25%, black 0% 50%) 50%/16px 16px;\n}\n\n.uppy-ImageCropper .cropper-modal {\n  opacity: 0.9;\n  background-color: white;\n}\n[data-uppy-theme=dark] .uppy-ImageCropper .cropper-modal {\n  opacity: 0.7;\n  background-color: black;\n}\n\n.uppy-ImageCropper .cropper-face {\n  opacity: 0;\n}\n\n.uppy-ImageCropper-range::-moz-range-track {\n  height: 4px;\n}\n.uppy-ImageCropper-range:focus::-webkit-slider-runnable-track, .uppy-ImageCropper-range:hover::-webkit-slider-runnable-track {\n  background: rgba(255, 255, 255, 0.5);\n}\n.uppy-ImageCropper-range:focus::-ms-fill-lower, .uppy-ImageCropper-range:hover::-ms-fill-lower {\n  background: rgba(255, 255, 255, 0.5);\n}\n.uppy-ImageCropper-range:focus::-ms-fill-upper, .uppy-ImageCropper-range:hover::-ms-fill-upper {\n  background: rgba(255, 255, 255, 0.5);\n}\n.uppy-ImageCropper-range:focus::-moz-range-track, .uppy-ImageCropper-range:hover::-moz-range-track {\n  background: rgba(255, 255, 255, 0.5);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
